<template>
  <div :class="$style.container" @click="$emit('edit')">
    <div :class="$style.content">
      <div :class="$style.title">
        {{ title }}
      </div>
      <div :class="$style.action">
        <span v-if="isNew" :class="$style.icon">
          <circle-plus-icon />
        </span>
        <template v-else>
          <span :class="$style.icon" @click.stop="$emit('rename')">
            <pencil-edit-icon />
          </span>
          <span :class="$style.icon" @click.stop="$emit('delete')">
            <trash-icon />
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import TrashIcon from 'atoms/icons/basic/Trash';
import PencilEditIcon from 'atoms/icons/basic/PencilEdit';
import CirclePlusIcon from 'atoms/icons/basic/CirclePlus';

export default {
  name: 'TemplatePreview',
  components: {
    TrashIcon,
    PencilEditIcon,
    CirclePlusIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    isNew: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative
    background: #1E1E2D
    border-radius: 5px
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)
    cursor: pointer

    &:hover
      background: #2F3049

  .content
    display: flex
    align-items: center
    padding: 20px

  .title
    flex: 1
    font-weight: 500
    font-size: 14px
    line-height: 17px
    +text-ellipsis

  .action
    flex: none
    display: flex
    margin-left: 12px

  .icon
    display: flex

    &:not(:last-child)
      margin-right: 10px

    svg

      path
        fill: #fff
</style>
